import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';

export default function Button({ btnLink, btnText, variant, icon }) {
  const className = variant ? `cs-text_btn ${variant}` : 'cs-text_btn';

  const isExternal = btnLink?.startsWith('http');

  if (isExternal) {
    return (
      <a
        href={btnLink}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
      >
        <span>{btnText}</span>
        {icon ? icon : <Icon icon="bi:arrow-right" />}
      </a>
    );
  }

  return (
    <Link to={btnLink} className={className}>
      <span>{btnText}</span>
      {icon ? icon : <Icon icon="bi:arrow-right" />}
    </Link>
  );
}